/**
 * Canonical excluded-from-price codes (SwissAligner / EasySmile invoice math).
 * Single source for frontend constants and backend invoice derivation.
 */
export const EXCLUDED_FROM_PRICE = [
  "4.8000",
  "4.0970",
  "TRAITEMENT_ALIGNEMENT",
] as const;
